import { theme } from "@compass/core";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import ImageResize from "quill-image-resize-module-react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "redux/store";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Quill } from "react-quill";

import "css/devextreme-fix.css";
import "css/devextreme.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";

import "react-quill/dist/quill.snow.css";

var Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register("modules/imageResize", ImageResize); // register Quill's ability to resie image
Quill.register(Block, true); // register Quill's output to use <div> instead of <p> as blocks

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  //<React.StrictMode> // this triggers useEffect component on mount twice
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
